import React from 'react';
import { Link } from 'react-router-dom';
import { HiCollection, HiUsers } from 'react-icons/hi';
import './NCAdmin.css';

export default function AdminDashboard() {
  return (
    <div className="nc-admin">
      <div className="nc-admin-eyebrow">NC LIVE</div>
      <h1 className="nc-admin-title" style={{ marginBottom: '3rem' }}>Admin</h1>

      <div className="nc-admin-grid">
        <Link to="/admin/games" className="nc-admin-card">
          <HiCollection className="nc-admin-card-icon" />
          <h2>Manage Games</h2>
          <p>Create and manage game schedules, assign streamers, monitor live status</p>
        </Link>
        <Link to="/admin/users" className="nc-admin-card">
          <HiUsers className="nc-admin-card-icon" />
          <h2>Manage Users</h2>
          <p>Approve streamers, assign roles, manage access</p>
        </Link>
      </div>
    </div>
  );
}
